/* À la carte minimum — live cart checks

   1. Live refresh: Trade's cart page only re-renders the totals part of the footer when a
      quantity changes, so the checkout button would stay disabled until a reload.
      After every cart change this script asks the theme for the current rule status
      (section "ala-cart-status") and updates the checkout buttons, the notice and the
      express checkout buttons right away.

   2. Safety net: before any checkout button continues (including the "Check out" button in
      the add-to-cart popup), it checks the rule again. If the minimum is not met, the
      customer is sent to the cart page, which shows the message.
*/
(() => {
  if (window.__alaGuardReady) return;
  window.__alaGuardReady = true;

  const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  const CHECKOUT_BUTTONS = '#checkout, #CartDrawer-Checkout';

  async function fetchStatus() {
    const res = await fetch(`${cartUrl}?section_id=ala-cart-status`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store',
    });
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ala-status]');
  }

  /* ---------- 1. Live refresh ---------- */
  function applyStatus(status) {
    if (!status) return;
    const blocked = status.dataset.blocked === 'true';
    const empty = (parseInt(status.dataset.items, 10) || 0) === 0;

    document.querySelectorAll(CHECKOUT_BUTTONS).forEach((btn) => {
      btn.disabled = blocked || empty;
    });

    document.querySelectorAll('[data-ala-express]').forEach((el) => {
      el.hidden = blocked;
    });

    const tpl = status.querySelector('template[data-ala-notice-html]');
    const notice = tpl ? tpl.innerHTML.trim() : '';
    document.querySelectorAll('[data-ala-notice-slot]').forEach((slot) => {
      if (slot.innerHTML.trim() !== notice) slot.innerHTML = notice; // only touch it when it changes
    });
  }

  let timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        applyStatus(await fetchStatus());
      } catch (err) {
        /* ignore — the checkout click check below still protects the rule */
      }
    }, 150);
  }

  // Trade publishes this after every cart change (cart page, drawer, product forms)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  // Fallback: watch the cart line items for re-renders
  const watch = () => {
    ['main-cart-items', 'CartDrawer'].forEach((id) => {
      const el = document.getElementById(id);
      if (el && !el.__alaWatched) {
        el.__alaWatched = true;
        new MutationObserver(refresh).observe(el, { childList: true, subtree: true });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  /* ---------- 2. Safety net on every checkout click ---------- */
  document.addEventListener(
    'click',
    async (e) => {
      const target = e.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]'
      );
      if (!target || target.disabled || target.dataset.alaChecked === '1') return;

      e.preventDefault();
      e.stopPropagation();

      let blocked = false;
      try {
        const status = await fetchStatus();
        blocked = !!status && status.dataset.blocked === 'true';
        applyStatus(status);
      } catch (err) {
        blocked = false; // never stop a sale because of a network hiccup
      }

      if (blocked) {
        if (!window.location.pathname.endsWith('/cart')) window.location.href = cartUrl;
        return;
      }

      target.dataset.alaChecked = '1';
      target.click(); // continue exactly as the customer intended
      setTimeout(() => delete target.dataset.alaChecked, 3000);
    },
    true
  );
})();
